import styled from 'styled-components';

export const StyledAvatarUpdateWrapper = styled.div`
  padding: ${({ theme }) => theme.spacing.xl};
  border-radius: ${({ theme }) => theme.borderRadius.md};
  border: ${({ theme }) => `${theme.border['xs']} solid ${theme.border.weak}`};
  background-color: ${({ theme }) => theme.background.weak};
  margin-bottom: ${({ theme }) => theme.spacing['2Xl']};
  text-align: center;
  h4 {
    margin: 0;
    padding: 0;
    ${({ theme }) => theme.body.regular.sm};
    &:first-letter {
      text-transform: capitalize;
    }
  }
`;
